import { SwaggerApiService } from './SwaggerApiService.service';
import { SwaggerApiRequestHeaders } from './SwaggerApiService.service';
import { eitherify, mapLeft, mapRight } from '@dev-stream/utils';
import { Inject, Optional, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BASE_URL, BusinessServerApiRootModule } from './BusinessServerApi.module';

@Injectable({ providedIn: BusinessServerApiRootModule })
export class BillingReportApiService extends SwaggerApiService {
    public constructor(http: HttpClient, @Optional() @Inject(BASE_URL) baseUrl: string) {
        super(http, baseUrl);
    }

    public GetPaymentReportFile_byId(id: string, requestHeaders?: SwaggerApiRequestHeaders) {
        const response = this.http.request('get', `${this.baseUrl}/api/v2/BillingReport/payment(id=${id})`, {
            headers: requestHeaders,
            responseType: 'blob',
        });

        return response.pipe(
            eitherify(),

            mapLeft((ex) => (ex instanceof HttpErrorResponse ? ex : ex))
        );
    }
}
